import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

const CheckIcon = ({ size = 24, color = '#34A853' }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Defs>
      <ClipPath id="clip0_check">
        <Rect width="24" height="24" fill="white" />
      </ClipPath>
    </Defs>
    <G clipPath="url(#clip0_check)">
      <Path
        d="M3.75 13.5L9 18.75L21 6.75"
        stroke={color}
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  </Svg>
);

export default CheckIcon;
